export default __webpack_public_path__ + "static/media/download-arrow-down.ebfe3d6a.svg";